var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "source_price_block" }, [
    _c("div", { staticClass: "form-group mt-2" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "wlocal" } }, [
        _vm._v(
          "\n            " + _vm._s(_vm.__t("SOURCE_PRICE")) + "*\n        "
        ),
      ]),
      _vm._v(" "),
      _vm.sources.length > 0
        ? _c(
            "div",
            {},
            [
              _c(
                "v-select",
                {
                  staticClass: "imc_reasons",
                  attrs: {
                    label: "name",
                    options: this.sources,
                    filter: _vm.searchSource,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _c("div", [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(option.name) +
                                    "\n                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(option.id) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1670482459
                  ),
                  model: {
                    value: _vm.active_source,
                    callback: function ($$v) {
                      _vm.active_source = $$v
                    },
                    expression: "active_source",
                  },
                },
                [
                  _c("template", { slot: "no-options" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.__t("CHOICE_REST")) +
                        "\n                "
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }